<template>
  <v-tooltip bottom>
    <template v-slot:activator="{ on, attrs }">
      <v-chip color="green" label small v-bind="attrs" v-on="on"
        >{{ aulas_confirmadas }}/{{ aulas_aguardando_confirmacao }}</v-chip
      >
    </template>
    <span>
      <div>Aulas Confirmadas: {{ aulas_confirmadas }}</div>
      <div>Aulas Aguardando confirmação: {{ aulas_aguardando_confirmacao }}</div>
    </span>
  </v-tooltip>
</template>

<script>
export default {
  props: {
    aulas_confirmadas: {
      type: Number,
      required: true,
    },
    aulas_aguardando_confirmacao: {
      type: Number,
      required: true,
    },
  },
};
</script>

<style></style>
